import { FormControlLabel, Typography } from '@mui/material';
import { Checkbox } from '@components/checkbox';

export const SUPPRESS_POLICY_GENERATED_EMAIL_LABEL = 'Do not send the policy package generated email to the broker';

/** Styled label shared by the controlled checkbox below and the FormSection CheckboxField variant. */
export const SuppressPolicyGeneratedEmailLabel = () => (
  <Typography variant='bodySmall' sx={{ color: 'text.secondary', mt: '2px' }}>
    {SUPPRESS_POLICY_GENERATED_EMAIL_LABEL}
  </Typography>
);

interface SuppressPolicyGeneratedEmailCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

/** Controlled opt-in to suppress the policy package generated email sent when the last subjectivity closes. */
export const SuppressPolicyGeneratedEmailCheckbox = ({
  checked,
  onChange,
  disabled,
}: SuppressPolicyGeneratedEmailCheckboxProps) => (
  <FormControlLabel
    sx={{ alignItems: 'flex-start' }}
    control={<Checkbox checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />}
    label={<SuppressPolicyGeneratedEmailLabel />}
  />
);
